import { render, staticRenderFns } from "./catelog.vue?vue&type=template&id=c95d1aee&scoped=true"
import script from "./catelog.vue?vue&type=script&lang=js"
export * from "./catelog.vue?vue&type=script&lang=js"
import style0 from "./catelog.vue?vue&type=style&index=0&id=c95d1aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d1aee",
  null
  
)

export default component.exports